import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Link } from '@/i18n/navigation';
import type { PlaylistFeaturedAccount } from '@/lib/data/types';
import { getOptionalCDNImageUrl } from '@/lib/utils/images';

interface PlaylistFeaturesProps {
  featuredAccounts: PlaylistFeaturedAccount[];
  maxItems?: number;
}

const PlaylistFeatures = ({ featuredAccounts, maxItems = 9 }: PlaylistFeaturesProps) => {
  const t = useTranslations('common');

  if (!featuredAccounts.length) {
    return null;
  }

  return (
    <div className="border rounded-5 p-4 mb-4">
      <h5>
        {t('playlists.sectionHeadings.featuredCurators')}
      </h5>
      <ul className="list-unstyled m-0 d-flex flex-wrap">
        {featuredAccounts.slice(0, maxItems).map((account) => {
          const imageUrl = getOptionalCDNImageUrl(account.image);
          
          return (
            <li className="my-3 col-12 col-sm-6 col-md-4" key={account.slug}>
              <Link
                href={`/playlists/curated-by/${account.slug}`}
                className="d-flex align-items-center text-decoration-none nav-link-hover"
              >
                {imageUrl ? (
                  <Image
                    width={40}
                    height={40}
                    className="rounded-circle me-2 border border-transparent transition"
                    src={imageUrl}
                    alt={account.name}
                  />
                ) : (
                  <span
                    className="rounded-circle me-2 bg-secondary d-flex justify-content-center align-items-center"
                    style={{ width: 40, height: 40 }}
                  >
                    <i className="bx bxs-user text-white"></i>
                  </span>
                )}
                <div>
                  <span className="text-white d-block fw-600 transition">
                    {account.name}
                  </span>
                  {account.username && (
                    <span className="text-muted fs-xs d-block">
                      @{account.username}
                    </span>
                  )}
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PlaylistFeatures; 